<template>
  <div class="row">
    <div class="col-md-8">
      <h3>Customers</h3>
    </div>
    <div class="col-md-2 offset-md-2">
      <router-link :to="{ name: 'Add Customer'}" style="float:right">
        <p-button type="primary" round>
          Add Customer
        </p-button>
      </router-link>
    </div>
    
    <div class="col-md-6" id="transactionPieChart" v-if="loaded">
      <chart-card
        :chart-data="overallChart"
                  chart-type="Pie"
                  title="Overall Inflow/Outflow"
                  description="Overall Inflow/Outflow for last 7 days">
        <template slot="header">
          <h5 class="card-title">Overall</h5>
          <p class="card-category">Inflow/Outflow</p>
        </template>
      </chart-card>
    </div>
    
    <div class="col-md-6" v-if="loaded">
      <card>
        <template slot="header">
          <h4 class="card-title">Daily Points</h4>
          <p class="card-category">Earning/Redeeming</p>
        </template>
        <bar-chart
          :labels="activityChart.labels"
          :height="250"
          :extra-options="activityChart.options"
          :datasets="activityChart.datasets">
        </bar-chart>
      </card>
    </div>

    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-sm-6">
              <el-select
                class="select-default"
                v-model="pagination.perPage"
                placeholder="Per page">
                <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </div>
            <div class="col-sm-6">
              <div class="pull-right">
                <fg-input class="input-sm"
                          placeholder="Search"
                          v-model="searchQuery"
                          addon-right-icon="nc-icon nc-zoom-split">
                </fg-input>
              </div>
            </div>
          </div>
          <div class="col-sm-12 mt-2">
            <el-table class="table-striped"
                      :data="queriedData"
                      empty-text="You have not added any transaction."
                      stripe
                      border
                      style="width: 100%">
              <el-table-column v-for="column in tableColumns"
                              :key="column.label"
                              :min-width="column.minWidth"
                              :prop="column.prop"
                              :label="column.label">
              </el-table-column>
            </el-table>
          </div>
          <div class="col-sm-6 pagination-info">
            <p class="category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
          </div>
          <div class="col-sm-6">
            <p-pagination class="pull-right"
                          v-model="pagination.currentPage"
                          :per-page="pagination.perPage"
                          :total="pagination.total">
            </p-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { Card } from 'src/components/UIComponents'
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard'
  import LineChart from 'src/components/UIComponents/Charts/LineChart'
  import BarChart from 'src/components/UIComponents/Charts/BarChart'
  import PieChart from 'src/components/UIComponents/Charts/PieChart'

  import Vue from 'vue'
  import {Table, TableColumn, Select, Option} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import categories from 'src/categories'
  
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)

  const tooltipOptions = {
    tooltipFillColor: "rgba(0,0,0,0.5)",
    tooltipFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
    tooltipFontSize: 14,
    tooltipFontStyle: "normal",
    tooltipFontColor: "#fff",
    tooltipTitleFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
    tooltipTitleFontSize: 14,
    tooltipTitleFontStyle: "bold",
    tooltipTitleFontColor: "#fff",
    tooltipYPadding: 6,
    tooltipXPadding: 6,
    tooltipCaretSize: 8,
    tooltipCornerRadius: 6,
    tooltipXOffset: 10,
  };
  export default {
    components: {
      Card,
      ChartCard,
      LineChart,
      BarChart,
      PieChart,
      PPagination
    },
    watch: {
      tableData: function(){
        this.queriedData
      }
    },

    computed: {
      pagedData () {
        return this.tableData.slice(this.from, this.to)
      },
      /***
       * Searches through table data and returns a paginated array.
       * Note that this should not be used for table with a lot of data as it might be slow!
       * Do the search and the pagination on the server and display the data retrieved from server instead.
       * @returns {computed.pagedData}
       */
      queriedData () {
        if (!this.searchQuery) {
          this.pagination.total = this.tableData.length
          return this.pagedData
        }
        let result = this.tableData
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch) {
              let rowValue = row[key].toString()
              if (rowValue.includes && rowValue.includes(this.searchQuery)) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination.total = result.length
        return result.slice(this.from, this.to)
      },
      to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      total () {
        this.pagination.total = this.tableData.length
        return this.tableData.length
      }
    },
    data() {
      return {
        loaded: false,
        activityChart: {
          
          datasets: [
            {
              label: "Outflow",
              borderColor: '#fcc468',
              fill: true,
              backgroundColor: '#fcc468',
              hoverBorderColor: '#fcc468',
              borderWidth: 8,
              data: [100, 120, 80, 100, 90, 130, 110, 100, 80, 110, 130, 140],
            },
          ],
          options: {
            tooltips: tooltipOptions
          }
        },
        overallChart: {
          labels: ['Inflow', 'Outflow'],
          datasets: [{
            label: "Overall",
            pointRadius: 0,
            pointHoverRadius: 0,
            backgroundColor: [
              '#6bd098',
              '#ef8157'
            ],
            borderWidth: 0,
            data: []
          }],
          options: {
            tooltips: tooltipOptions,
            legend: {
              display: true
            }
          }
        },
        pagination: {
          perPage: 10,
          currentPage: 1,
          perPageOptions: [10, 25, 50],
          total: 0
        },
        searchQuery: '',
        propsToSearch: ['customer', 'email'],
        tableColumns: [
          {
            prop: 'name',
            label: 'Customer',
            minWidth: 100
          },
          {
            prop: 'contact',
            label: 'Contact',
            minWidth: 150
          },
         
          {
            prop: "purchases",
            label: 'Purchase Info',
            minWidth: 120
          },
          {
            prop: "earned",
            label: 'Earned',
            
          },
          {
            prop: "redeemed",
            label: 'Redeemed',
            
          },
          {
            prop: "balance",
            label: 'Balance',
            
          },
        ],
        tableData: []
      }
    },
    methods: {
      
      handleDelete (index, row) {
        this.$http.delete('/transactions/' + row.id)
        .then(response=>{
          if(response.data.created_at){
            
          }
          
          let indexToDelete = this.tableData.findIndex((tableRow) => tableRow.id === row.id)
          if (indexToDelete >= 0) {
            this.tableData.splice(indexToDelete, 1)
          }
          
        })
        .catch(error =>{
          //what to do when there is an error with the registration
          
        })
        
      },
      getCustomers () {
        this.$http.get ('/addons/reward/programs/7/customers')
        .then(response => {
            
          response.data.map((e)=>{
            e.contact = e.email + "\n" + '08098747338'
            e.purchases = e.created_at + '\n' + e.updated_at
            e.balance = e.earned - e.redeemed
          })

          this.tableData = response.data
          console.log(this.tableData)
        })
        .catch(err => console.error(err))
      },

     
    },
    async mounted () {
      this.getCustomers ()

    }
  }
</script>
<style lang="css" scoped>
  thead .cell {
    font-size: 10px;
  }

  td .cell {
    white-space: pre-line !important;
  }
</style>
